import { render, staticRenderFns } from "./intelligentCreateQues.vue?vue&type=template&id=3fee5537"
import script from "./intelligentCreateQues.vue?vue&type=script&lang=js"
export * from "./intelligentCreateQues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports